import { uploadEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';
import type { GenericAttachment } from '@/styles/GenericAttachmentsSection';

/** Upload path shared by the edit-mode form and the create-mode "upload after
 *  the record exists" step: the shared implementation in
 *  lib/entity-attachments.ts, naming only the entity type. */
export function uploadInvoiceAttachments(
  recordId: string | undefined,
  files: File[],
  companyId: string,
  userId: string
): Promise<GenericAttachment[]> {
  return uploadEntityAttachments('invoice', recordId, files, companyId, userId);
}

export function deleteInvoiceAttachment(
  attachmentId: string,
  _companyId: string,
  userId: string,
  _storagePathOrUrl?: string
): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}
